// A paragraph holding only whitespace, non-breaking spaces and inline formatting tags, e.g. <p><strong>&nbsp;</strong></p>.
const WHITESPACE_PARAGRAPH = /<p(\s[^>]*)?>(?:\s|&nbsp;|\u00a0|<\/?(?:em|strong|b|i|u|span)(?:\s[^>]*)?>)*<\/p>/gi;
const NBSP = /&nbsp;|\u00a0/i;

// Turns paragraphs whose only content is a non-breaking space into <p><br/></p>, so they keep their empty line once &nbsp; is replaced by a regular space.
// Paragraphs without a non-breaking space (<p></p>, <p><em> </em></p>) are left as they are.
export function convertNbspEmptyLines(html: string): string {
  return html.replace(WHITESPACE_PARAGRAPH, (match: string, attributes = '') => {
    return NBSP.test(match) ? `<p${attributes}><br/></p>` : match;
  });
}
